var React = require('react');

function Pending (props) {
    return React.createElement("svg",props,React.createElement("circle",{"stroke":"#A3AFC2","strokeWidth":"2","cx":"12","cy":"12","r":"11","fill":"none","fillRule":"evenodd"}));
}

Pending.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Pending;

Pending.default = Pending;
